import { render, staticRenderFns } from "./RegistrationInfoDialog.vue?vue&type=template&id=2a47bed2&scoped=true"
import script from "./RegistrationInfoDialog.vue?vue&type=script&lang=js"
export * from "./RegistrationInfoDialog.vue?vue&type=script&lang=js"
import style0 from "./RegistrationInfoDialog.vue?vue&type=style&index=0&id=2a47bed2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a47bed2",
  null
  
)

export default component.exports